/**
 * いくつかのタグから複数を選ぶ(押すと選択/解除。2026-10-15 追加: 面談の課題)。業務ロジックは持たない。
 * 選択中は aria-pressed。Tab で各タグに移り Enter / Space で切り替える。折り返して並べる。
 */
export default function TagPicker({ label, options, value, onChange, disabled = false }: { label: string; options: readonly string[]; value: string[]; onChange: (next: string[]) => void; disabled?: boolean }) {
  const toggle = (o: string) => onChange(value.includes(o) ? value.filter((v) => v !== o) : options.filter((x) => x === o || value.includes(x)));
  return (
    <div className="ui-tags" role="group" aria-label={label}>
      {options.map((o) => (
        <button key={o} type="button" className="ui-tag" aria-pressed={value.includes(o)} onClick={() => toggle(o)} disabled={disabled}>
          {o}
        </button>
      ))}
    </div>
  );
}
